import { Module } from "vuex";
import { initialState, IPolarisBiState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const polarisbi: Module<IPolarisBiState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { polarisbi };
